module.exports = {
    nullable: '必填',
    maxLen: '长度不能超过 {{length}}',
    minLen: '长度不能小于 {{length}}',
    max: '不能大于 {{number}}',
    min: '不能小于 {{number}}',
    number: '必须是数字',
    format: '格式错误',
    regexError: '{{regex}} 不是一个合法的正则表达式。'
};


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locale.zh-cn.js
// module id = 11
// module chunks = 0